import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule, MatCardModule, MatCheckboxModule, MatDatepickerModule, MatExpansionModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule,
  MatSortModule,
  MatTableModule, MatToolbarModule, MatTooltipModule
} from '@angular/material';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { PagosDetalleComponent } from 'app/cobranza/pagos/pagos-detalle/pagos-detalle.component';
import { ComponentesGlobalesModule } from 'app/componentes-globales/componentes-globales.module';
import { InlineBlackListComponent } from 'app/componentes-globales/inline-black-list/inline-black-list.component';
import { InlineContactosComponent } from 'app/componentes-globales/inline-contactos/inline-contactos.component';
import { SubDashboardComponent } from 'app/configuracion/subdashboard/subdashboard.component';
import { EditarTipoCambioComponent } from 'app/contabilidad/editar-tipo-cambio/editar-tipo-cambio.component';
import { ListaTipoCambioComponent } from 'app/contabilidad/lista/lista-tipo-cambio.component';
import { NuevoTipoCambioComponent } from 'app/contabilidad/nuevo-tipo-cambio/nuevo-tipo-cambio.component';
import { AvalJuridicoComponent } from 'app/contrato-marco/aval-juridico/aval-juridico.component';
import { NuevoContactoPagareComponent } from 'app/contrato-marco/nuevo-contacto-pagare/nuevo-contacto-pagare.component';
import { UppercaseDirective } from 'app/Directives/uppercase.directive';
import { ListadoPagareComponent } from 'app/empresas/pagares/listado-pagare/listado-pagare.component';
import { PagaresComponent } from 'app/empresas/pagares/pagares.component';
import { BloqueomasivoComponent } from 'app/empresas/proveedores/bloqueomasivo/bloqueomasivo.component';
import { DetalleListadoComponent } from 'app/facturacion/listado-cpe/detalle-listado/detalle-listado.component';
import { LibroReclamacionesComponent } from 'app/libro-reclamaciones/libro-reclamaciones.component';
import { DetalleQuejasReclamosComponent } from 'app/libro-reclamaciones/quejas-reclamos/detalle-quejas-reclamos/detalle-quejas-reclamos.component';
import { ListadoQuejasReclamosComponent } from 'app/libro-reclamaciones/quejas-reclamos/listado-quejas-reclamos/listado-quejas-reclamos.component';
import { QuejasReclamosComponent } from 'app/libro-reclamaciones/quejas-reclamos/quejas-reclamos.component';
import { DetalleLiquidacionesComponent } from 'app/liquidacion/liquidaciones/listado-liquidaciones/detalle-liquidaciones/detalle-liquidaciones.component';
import { ListadoResumenComponent } from 'app/liquidacion/resumen-liquidacion/listado-resumen/listado-resumen.component';
import { DetalleResumenComponent } from 'app/liquidacion/resumen-liquidacion/nuevo-resumen/detalle-resumen/detalle-resumen.component';
import { NuevoResumenComponent } from 'app/liquidacion/resumen-liquidacion/nuevo-resumen/nuevo-resumen.component';
import { ResumenLiquidacionComponent } from 'app/liquidacion/resumen-liquidacion/resumen-liquidacion.component';
import { FormularioMetaComponent } from 'app/meta/area/nuevo-area/formulario-meta/formulario-meta.component';
import { TablaMetaComponent } from 'app/meta/area/nuevo-area/tabla-meta/tabla-meta.component';
import { CargaMasivaComponent } from 'app/negociables/factura/carga-masiva/carga-masiva.component';
import { DetalleLineaComponent } from 'app/operaciones/linea-adquirente/detalle-linea/detalle-linea.component';
import { LineaAdquirenteComponent } from 'app/operaciones/linea-adquirente/linea-adquirente.component';
import { ListaLineasComponent } from 'app/operaciones/linea-adquirente/lista-lineas/lista-lineas.component';
import { NuevaLineaComponent } from 'app/operaciones/linea-adquirente/nueva-linea/nueva-linea.component';
import { ProspectosDetalleComponent } from 'app/operaciones/prospectos/prospectos-detalle/prospectos-detalle.component';
import { DetComprobanteElectronicoComponent } from 'app/reportes/rep-contabilidad/comprobante-electronico/det-comprobante-electronico/det-comprobante-electronico.component';
import { ListaComprobanteElectronicoComponent } from 'app/reportes/rep-contabilidad/comprobante-electronico/lista-comprobante-electronico/lista-comprobante-electronico.component';
import { ComprobanteIfComponent } from 'app/reportes/rep-contabilidad/comprobante-if/comprobante-if.component';
import { ListaComprobanteIfComponent } from 'app/reportes/rep-contabilidad/comprobante-if/lista-comprobante-if/lista-comprobante-if.component';
import { ListadoRepConciliacionesComponent } from 'app/reportes/rep-contabilidad/listado-rep-conciliaciones/listado-rep-conciliaciones.component';
import { RepContabilidadComponent } from 'app/reportes/rep-contabilidad/rep-contabilidad.component';
import { DetallePagoAdqComponent } from 'app/reportes/rep-finanzas/detalle-pago-adq/detalle-pago-adq.component';
import { ListadoPagoAdqComponent } from 'app/reportes/rep-finanzas/listado-pago-adq/listado-pago-adq.component';
import { RepConciliacionComponent } from 'app/reportes/rep-finanzas/rep-conciliacion/rep-conciliacion.component';
import { RepMensualComponent } from 'app/reportes/rep-finanzas/rep-mensual/rep-mensual.component';
import { ListadoRepMarketingComponent } from 'app/reportes/rep-marketing/listado-rep-marketing/listado-rep-marketing.component';
import { RepMarketingComponent } from 'app/reportes/rep-marketing/rep-marketing.component';
import { ReportesModule } from 'app/reportes/reportes.module';
import { AsignarSectorComponent } from 'app/riesgo/configuracion-riesgo/asignar-sector/asignar-sector.component';
import { ConfiguracionRiesgoComponent } from 'app/riesgo/configuracion-riesgo/configuracion-riesgo.component';
import { ListadoSectorComponent } from 'app/riesgo/configuracion-riesgo/listado-sector/listado-sector.component';
import { NuevoSectorComponent } from 'app/riesgo/configuracion-riesgo/nuevo-sector/nuevo-sector.component';
import { SectorEmpresaComponent } from 'app/riesgo/configuracion-riesgo/sector-empresa/sector-empresa.component';
import { ListaNegraComponent } from 'app/riesgo/empresa-riesgo/lista-negra/lista-negra.component';
import { SecurityService } from 'app/services/security/security.service';
import { VerificacionPlanillaDesembolsoComponent } from 'app/tesoreria/desembolso/verificacion-planilla-desembolso/verificacion-planilla-desembolso.component';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { NgxMaskModule } from 'ngx-mask';
import { CavaliComponent } from '../../cavali/cavali.component';
import { ListadoCavaliComponent } from '../../cavali/listado-cavali/listado-cavali.component';
import { ProcesoCavaliComponent } from '../../cavali/proceso-cavali/proceso-cavali.component';
import { RegistrarCavaliComponent } from '../../cavali/registrar-cavali/registrar-cavali.component';
import { CobranzaComponent } from '../../cobranza/cobranza.component';
import { CobranzasComponent } from '../../cobranza/cobranzas/cobranzas.component';
import { ListadoCobranzaComponent } from '../../cobranza/cobranzas/listado-cobranza/listado-cobranza.component';
import { InsertarCobranzaComponent } from '../../cobranza/cobranzas/nuevo-cobranza/insertar-cobranza/insertar-cobranza.component';
import { NuevoCobranzaComponent } from '../../cobranza/cobranzas/nuevo-cobranza/nuevo-cobranza.component';
import { DeudasComponent } from '../../cobranza/deudas/deudas.component';
import { FacturacionDeudaComponent } from '../../cobranza/deudas/listado-deudas/facturacion-deuda/facturacion-deuda.component';
import { ListadoDeudasComponent } from '../../cobranza/deudas/listado-deudas/listado-deudas.component';
import { RegistroDeudasComponent } from '../../cobranza/deudas/listado-deudas/registro-deudas/registro-deudas.component';
import { AdquirenteCuotaComponent } from '../../cobranza/pagos/adquirente-cuota/adquirente-cuota.component';
import { AdquirentePagoComponent } from '../../cobranza/pagos/adquirente-pago/adquirente-pago.component';
import { DetallePagoComponent } from '../../cobranza/pagos/detalle-pago/detalle-pago.component';
import { EditarAdquirenteComponent } from '../../cobranza/pagos/editar-adquirente/editar-adquirente.component';
import { ListadoPagoComponent } from '../../cobranza/pagos/listado-pago/listado-pago.component';
import { PagosComponent } from '../../cobranza/pagos/pagos.component';
import { AccesoComponent } from '../../configuracion/acceso/acceso.component';
import { ListadoAccesoComponent } from '../../configuracion/acceso/listado-acceso/listado-acceso.component';
import { NuevoAccesoComponent } from '../../configuracion/acceso/nuevo-acceso/nuevo-acceso.component';
import { ComponentesComponent } from '../../configuracion/componentes/componentes.component';
import { ListadoComponenteComponent } from '../../configuracion/componentes/listado-componente/listado-componente.component';
import { NuevoComponenteComponent } from '../../configuracion/componentes/nuevo-componente/nuevo-componente.component';
import { PermisoComponenteComponent } from '../../configuracion/componentes/permiso-componente/permiso-componente.component';
import { EmpresaSegComponent } from '../../configuracion/empresa-seg/empresa-seg.component';
import { ListadoComponent } from '../../configuracion/empresa-seg/listado/listado.component';
import { NuevoEmpresaComponent } from '../../configuracion/empresa-seg/nuevo-empresa/nuevo-empresa.component';
import { NuevoParametroComponent } from '../../configuracion/empresa-seg/parametro/nuevo-parametro/nuevo-parametro.component';
import { ParametroComponent } from '../../configuracion/empresa-seg/parametro/parametro.component';
import { DetalleGuiaComponent } from '../../configuracion/guias/detalle-guia/detalle-guia.component';
import { GuiasComponent } from '../../configuracion/guias/guias.component';
import { ListadoGuiaComponent } from '../../configuracion/guias/listado-guia/listado-guia.component';
import { NuevoGuiaComponent } from '../../configuracion/guias/nuevo-guia/nuevo-guia.component';
import { ListadoPermisoComponent } from '../../configuracion/permiso/listado-permiso/listado-permiso.component';
import { NuevoPermisoComponent } from '../../configuracion/permiso/nuevo-permiso/nuevo-permiso.component';
import { PermisoComponent } from '../../configuracion/permiso/permiso.component';
import { ListadoRolComponent } from '../../configuracion/rol/listado-rol/listado-rol.component';
import { NuevoRolComponent } from '../../configuracion/rol/nuevo-rol/nuevo-rol.component';
import { RolComponent } from '../../configuracion/rol/rol.component';
import { ListadoSistemaComponent } from '../../configuracion/sistema/listado-sistema/listado-sistema.component';
import { NuevoSistemaComponent } from '../../configuracion/sistema/nuevo-sistema/nuevo-sistema.component';
import { SistemaComponent } from '../../configuracion/sistema/sistema.component';
import { ListaUsuarioComponent } from '../../configuracion/usuarios/lista/lista-usuario.component';
import { NuevoUsuarioComponent } from '../../configuracion/usuarios/nuevo-usuario/nuevo-usuario.component';
import { UsuarioComponent } from '../../configuracion/usuarios/usuario.component';
import { ContabilidadComponent } from '../../contabilidad/contabilidad.component';
import { ContratoMarcoComponent } from '../../contrato-marco/contrato-marco.component';
import { ListadoContratoMarcoComponent } from '../../contrato-marco/listado-contrato-marco/listado-contrato-marco.component';
import { NuevoPagareComponent } from '../../contrato-marco/pagare/nuevo-pagare/nuevo-pagare.component';
import { PagareComponent } from '../../contrato-marco/pagare/pagare.component';
import { AdjuntarLogoComponent } from '../../empresas/adjuntar-logo/adjuntar-logo.component';
import { AdquirentesComponent } from '../../empresas/adquirentes/adquirentes.component';
import { ListAdquirenteComponent } from '../../empresas/adquirentes/list-adquirente/list-adquirente.component';
import { RegAdquirenteComponent } from '../../empresas/adquirentes/reg-adquirente/reg-adquirente.component';

import { FactorComponent } from '../../empresas/factor/factor.component';
import { ListFactorComponent } from '../../empresas/factor/list-factor/list-factor.component';
import { RegFactorComponent } from '../../empresas/factor/reg-factor/reg-factor.component';

import { AdjuntarArchivoContactoComponent } from '../../empresas/contactos/adjuntar-archivo/adjuntar-archivo-contacto.component';
import { ContactosComponent } from '../../empresas/contactos/contactos.component';
import { NuevoContactoComponent } from '../../empresas/contactos/nuevo-contacto/nuevo-contacto.component';
import { NuevoCorteComponent } from '../../fondo/financiamiento/acfin/nuevo-corte/nuevo-corte.component';
import { ContratosMarcoComponent } from '../../empresas/contratos-marco/contratos-marco.component';
import { NuevoContratoMarcoComponent } from '../../empresas/contratos-marco/nuevo-contrato-marco/nuevo-contrato-marco.component';
import { EmpresasComponent } from '../../empresas/empresas.component';
import { ConfInversoresComponent } from '../../empresas/inversores/conf-inversores/conf-inversores.component';
import { InversoresComponent } from '../../empresas/inversores/inversores.component';
import { ListInversoresComponent } from '../../empresas/inversores/list-inversores/list-inversores.component';
import { ListadoEmpresasComponent } from '../../empresas/listado-empresas/listado-empresas.component';
import { DesbloqueoMasivoComponent } from '../../empresas/proveedores/desbloqueo-masivo/desbloqueo-masivo.component';
import { ListProveedorComponent } from '../../empresas/proveedores/list-proveedor/list-proveedor.component';
import { ProveedoresComponent } from '../../empresas/proveedores/proveedores.component';
import { RegInversorComponent } from '../../empresas/inversores/reg-inversor/reg-inversor.component';
import { RegProveedorComponent } from '../../empresas/proveedores/reg-proveedor/reg-proveedor.component';
import { NuevoRefBancariaComponent } from '../../empresas/ref-bancarias/nuevo-ref-bancaria/nuevo-ref-bancaria.component';
import { RefBancariasComponent } from '../../empresas/ref-bancarias/ref-bancarias.component';
import { FactoringComponent } from '../../factoring/factoring.component';
import { DetalleNotaCpeComponent } from '../../facturacion/detalle-nota-cpe/detalle-nota-cpe.component';
import { FondosComponent } from '../../fondo/concentracion-fondo/fondos/fondos.component';
import { ListadoFondosComponent } from '../../fondo/concentracion-fondo/fondos/listado-fondos/listado-fondos.component';
import { NuevoFondoComponent } from '../../fondo/concentracion-fondo/fondos/nuevo-fondo/nuevo-fondo.component';
import { GarantiasComponent } from '../../fondo/concentracion-fondo/garantias/garantias.component';
import { ListadoGarantiasComponent } from '../../fondo/concentracion-fondo/garantias/listado-garantias/listado-garantias.component';
import { NuevaGarantiaComponent } from '../../fondo/concentracion-fondo/garantias/nueva-garantia/nueva-garantia.component';
import { InversionComponent } from '../../inversion/inversion.component';
import { InversionistasComponent } from '../../inversion/inversionistas/inversionistas.component';
import { ListadoInversionistasComponent } from '../../inversion/inversionistas/listado-inversionistas/listado-inversionistas.component';
import { GenerarInversionComponent } from '../../inversion/inversionistas/nuevo-inversion/generar-inversion/generar-inversion.component';
import { NuevoInversionComponent } from '../../inversion/inversionistas/nuevo-inversion/nuevo-inversion.component';
import { LiquidacionComponent } from '../../liquidacion/liquidacion.component';
import { LiquidacionesComponent } from '../../liquidacion/liquidaciones/liquidaciones.component';
import { CorreoLiquidacionesComponent } from '../../liquidacion/liquidaciones/listado-liquidaciones/correo-liquidaciones/correo-liquidaciones.component';
import { ListadoLiquidacionesComponent } from '../../liquidacion/liquidaciones/listado-liquidaciones/listado-liquidaciones.component';
import { GenerarLiquidacionComponent } from '../../liquidacion/liquidaciones/nueva-liquidacion/generar-liquidacion/generar-liquidacion.component';
import { NuevaLiquidacionComponent } from '../../liquidacion/liquidaciones/nueva-liquidacion/nueva-liquidacion.component';
import { PlanillaLiquidacionesComponent } from '../../liquidacion/liquidaciones/planilla-liquidaciones/planilla-liquidaciones.component';
import { AreaComponent } from '../../meta/area/area.component';
import { ListadoAreaComponent } from '../../meta/area/listado-area/listado-area.component';
import { NuevoAreaComponent } from '../../meta/area/nuevo-area/nuevo-area.component';
import { MetaComponent } from '../../meta/meta.component';
import { AdjuntarArchivoComponent } from '../../negociables/adjuntar-archivo/adjuntar-archivo.component';
import { FacturaElectronicaComponent } from '../../negociables/factura/factura-electronica/factura-electronica.component';


import { FacturaElectronicaccComponent } from '../../negociables/facturacc/factura-electronica-cc/factura-electronica-cc.component';
import { FacturaccComponent } from '../../negociables/facturacc/facturacc.component';

import { FacturaFisicaComponent } from '../../negociables/factura/factura-fisica/factura-fisica.component';
import { FacturaComponent } from '../../negociables/factura/factura.component';
import { ListadoDocNegComponent } from '../../negociables/listado-doc-neg/listado-doc-neg.component';
import { NegociablesComponent } from '../../negociables/negociables.component';
import { ReciboHonorarioComponent } from '../../negociables/recibo/recibo-honorario/recibo-honorario.component';
import { ReciboComponent } from '../../negociables/recibo/recibo.component';
import { SelecArchivoComponent } from '../../negociables/selec-archivo/selec-archivo.component';
import { DetalleEvaluacionOperacionComponent } from '../../operaciones/evaluacion-operacion/detalle-evaluacion-operacion/detalle-evaluacion-operacion.component';
import { EvaluacionOperacionComponent } from '../../operaciones/evaluacion-operacion/evaluacion-operacion.component';
import { ListaDocumentosComponent } from '../../operaciones/evaluacion-operacion/lista-documentos/lista-documentos.component';
import { ListaEvaluacionOperacionComponent } from '../../operaciones/evaluacion-operacion/lista-evaluacion-operacion/lista-evaluacion-operacion.component';
import { NuevoEvaluacionOperacionComponent } from '../../operaciones/evaluacion-operacion/nuevo-evaluacion-operacion/nuevo-evaluacion-operacion.component';
import { ListadoOperacionComponent } from '../../operaciones/operacion/listado-operacion/listado-operacion.component';
import { GenerarOperacionComponent } from '../../operaciones/operacion/nueva-operacion/generar-operacion/generar-operacion.component';
import { NuevaOperacionComponent } from '../../operaciones/operacion/nueva-operacion/nueva-operacion.component';
import { OperacionDetalleComponent } from '../../operaciones/operacion/operacion-detalle/operacion-detalle.component';
import { OperacionComponent } from '../../operaciones/operacion/operacion.component';
import { OperacionesComponent } from '../../operaciones/operaciones.component';

import { ListadoConfirmingComponent } from '../../operaciones/confirming/listado-confirming/listado-confirming.component';
import { GenerarConfirmingComponent } from '../../operaciones/confirming/nuevo-confirming/generar-confirming/generar-confirming.component';
import { NuevaConfirmingComponent } from '../../operaciones/confirming/nuevo-confirming/nuevo-confirming.component';
import { ConfirmingDetalleComponent } from '../../operaciones/confirming/confirming-detalle/confirming-detalle.component';
import { ConfirmingComponent } from '../../operaciones/confirming/confirming.component'; 


import { ListadoDocumentosAsociadosComponent } from '../../operaciones/proformas/listado-documentos-asociados/listado-documentos-asociados.component';
import { ListadoProformasComponent } from '../../operaciones/proformas/listado-proformas/listado-proformas.component';
import { NuevoProformaComponent } from '../../operaciones/proformas/nuevo-proforma/nuevo-proforma.component';
import { ProformaDetalleComponent } from '../../operaciones/proformas/proforma-detalle/proforma-detalle.component';
import { ProformasComponent } from '../../operaciones/proformas/proformas.component';
import { ListadoOperacionesProspectosComponent } from '../../operaciones/prospectos/listado-operaciones-prospectos/listado-operaciones-prospectos.component';
import { NuevoProspectosComponent } from '../../operaciones/prospectos/nuevo-prospectos/nuevo-prospectos.component';
import { ProspectosComponent } from '../../operaciones/prospectos/prospectos.component';
import { DetalleSimuladorComponent } from '../../operaciones/simulador/detalle-simulador/detalle-simulador.component';
import { ListadoSimuladorComponent } from '../../operaciones/simulador/listado-simulador/listado-simulador.component';
import { InsertarSimuladorDetalleRhComponent } from '../../operaciones/simulador/simulador-nuevo/insertar-simulador-detalle-rh/insertar-simulador-detalle-rh.component';
import { InsertarSimuladorDetalleComponent } from '../../operaciones/simulador/simulador-nuevo/insertar-simulador-detalle/insertar-simulador-detalle.component';
import { InsertarSimuladorObjetivoComponent } from '../../operaciones/simulador/simulador-nuevo/insertar-simulador-objetivo/insertar-simulador-objetivo.component';
import { SimuladorNuevoComponent } from '../../operaciones/simulador/simulador-nuevo/simulador-nuevo.component';
import { SimuladorComponent } from '../../operaciones/simulador/simulador.component';
import { ListadoSolicitudDesComponent } from '../../operaciones/solicitud-desembolso/listado-solicitud-des/listado-solicitud-des.component';
import { NotificarSolicitudDesembolsoComponent } from '../../operaciones/solicitud-desembolso/notificar-solicitud-desembolso/notificar-solicitud-desembolso.component';
import { GenerarSolicitudDesComponent } from '../../operaciones/solicitud-desembolso/nuevo-solicitud-des/generar-solicitud-des/generar-solicitud-des.component';
import { NuevoSolicitudDesComponent } from '../../operaciones/solicitud-desembolso/nuevo-solicitud-des/nuevo-solicitud-des.component';
import { SolicitudDesDetalleComponent } from '../../operaciones/solicitud-desembolso/solicitud-des-detalle/solicitud-des-detalle.component';
import { SolicitudDesembolsoComponent } from '../../operaciones/solicitud-desembolso/solicitud-desembolso.component';
import { PersonaComponent } from '../../persona/persona.component';
import { SafeUrlPipe } from '../../pipes/safe-url.pipe';
import { ListadoRepComercialComponent } from '../../reportes/rep-comercial/listado-rep-comercial/listado-rep-comercial.component';
import { ReporteCalculoComisionComponent } from '../../reportes/rep-comercial/calculo-comision/calculo-comision.component';

import { ReporteClienteObligadoComponent } from '../../reportes/rep-comercial/cliente-obligado/cliente-obligado.component';
import { ReporteNumeroOperacionesComponent } from '../../reportes/rep-comercial/numero-operaciones/numero-operaciones.component';

import { ReporteFacturaNegociadaComponent } from '../../reportes/rep-comercial/factura-negociada/factura-negociada.component';
import { RepComercialComponent } from '../../reportes/rep-comercial/rep-comercial.component';
import { ComprobanteElectronicoComponent } from '../../reportes/rep-contabilidad/comprobante-electronico/comprobante-electronico.component';
import { DetalleRepConcilComponent } from '../../reportes/rep-contabilidad/detalle-rep-concil/detalle-rep-concil.component';
import { AccialComponent } from '../../reportes/rep-finanzas/accial/accial.component';
import { FondoInversionComponent } from '../../reportes/rep-finanzas/fondo-inversion/fondo-inversion.component';
import { RepFinanzasComponent } from '../../reportes/rep-finanzas/rep-finanzas.component';
import { ReportesComponent } from '../../reportes/reportes.component';
import { CarteraRiesgoComponent } from '../../riesgo/cartera-riesgo/cartera-riesgo.component';
import { ListadoCarteraRiesgoComponent } from '../../riesgo/cartera-riesgo/listado-cartera-riesgo/listado-cartera-riesgo.component';
import { DocumentosSubastaComponent } from '../../riesgo/documentos-subasta/documentos-subasta.component';
import { ListadoDnSubastaComponent } from '../../riesgo/documentos-subasta/listado-dnsubasta/listado-dnsubasta.component';
import { ListadoDocumentosXSubastarComponent } from '../../riesgo/documentos-subasta/listado-documentos-xsubastar/listado-documentos-xsubastar.component';
import { NuevoDnSubastaComponent } from '../../riesgo/documentos-subasta/nuevo-dnsubasta/nuevo-dnsubasta.component';
import { EmpresaRiesgoComponent } from '../../riesgo/empresa-riesgo/empresa-riesgo.component';
import { ContactoEmpresaComponent } from '../../riesgo/empresa-riesgo/listado-empresa-riesgo/contacto-empresa/contacto-empresa.component';
import { ListadoEmpresaRiesgoComponent } from '../../riesgo/empresa-riesgo/listado-empresa-riesgo/listado-empresa-riesgo.component';
import { ListadoExcepcionesComponent } from '../../riesgo/empresa-riesgo/listado-excepciones/listado-excepciones.component';
import { NuevaEmpresaRiesgoComponent } from '../../riesgo/empresa-riesgo/nueva-empresa-riesgo/nueva-empresa-riesgo.component';
import { ListadoProspectosComponent } from '../../riesgo/prospecto-respuesta/listado-prospectos/listado-prospectos.component';
import { NuevaRespuestaProspectoComponent } from '../../riesgo/prospecto-respuesta/nueva-respuesta-prospecto/nueva-respuesta-prospecto.component';
import { ProspectoRespuestaComponent } from '../../riesgo/prospecto-respuesta/prospecto-respuesta.component';
import { RiesgoComponent } from '../../riesgo/riesgo.component';
import { Error1Component } from '../../shared/error1/error1.component';
import { SharedModule } from '../../shared/shared.module';
import { ConfirmarDesembolsoComponent } from '../../tesoreria/desembolso/confirmar-desembolso/confirmar-desembolso.component';
import { DesembolsoComponent } from '../../tesoreria/desembolso/desembolso.component';
import { ListadoDesembolsoComponent } from '../../tesoreria/desembolso/listado-desembolso/listado-desembolso.component';
import { GenerarDesembolsoComponent } from '../../tesoreria/desembolso/nuevo-desembolso/generar-desembolso/generar-desembolso.component';
import { NuevoDesembolsoComponent } from '../../tesoreria/desembolso/nuevo-desembolso/nuevo-desembolso.component';
import { GenerarDesembolsoLiquidacionComponent } from '../../tesoreria/desembolso/nuevo-planillaLiquidacion/generar-desembolsoLiquidacion/generar-desembolsoLiquidacion.component';
import { NuevoPlanillaLiquidacionComponent } from '../../tesoreria/desembolso/nuevo-planillaLiquidacion/nuevo-planillaLiquidacion.component';
import { TesoreriaComponent } from '../../tesoreria/tesoreria.component';
import { UpgradeComponent } from '../../upgrade/upgrade.component';
import { PagarDeudaComponent } from './../../cobranza/deudas/listado-deudas/pagar-deuda/pagar-deuda.component';
import { CancelarCobranzaJudicialComponent } from './../../cobranza/negociaciones/listado-cobranza-judicial/cancelar-cobranza-judicial/cancelar-cobranza-judicial.component';
import { DetalleCobranzaJudicialComponent } from './../../cobranza/negociaciones/listado-cobranza-judicial/detalle-cobranza-judicial/detalle-cobranza-judicial.component';
import { ListadoCobranzaJudicialComponent } from './../../cobranza/negociaciones/listado-cobranza-judicial/listado-cobranza-judicial.component';
import { NuevoCobranzaJudicialComponent } from './../../cobranza/negociaciones/listado-cobranza-judicial/nuevo-cobranza-judicial/nuevo-cobranza-judicial.component';
import { CancelarReprogramacionComponent } from './../../cobranza/negociaciones/listado-reprogramacion/cancelar-reprogramacion/cancelar-reprogramacion.component';
import { DetalleReprogramacionComponent } from './../../cobranza/negociaciones/listado-reprogramacion/detalle-reprogramacion/detalle-reprogramacion.component';
import { ListadoReprogramacionComponent } from './../../cobranza/negociaciones/listado-reprogramacion/listado-reprogramacion.component';
import { NuevoReprogramacionComponent } from './../../cobranza/negociaciones/listado-reprogramacion/nuevo-reprogramacion/nuevo-reprogramacion.component';
import { NegociacionesComponent } from './../../cobranza/negociaciones/negociaciones.component';
import { InlineEditComponent } from './../../componentes-globales/inline-edit/inline-edit.component';

import { AdjuntarArchivoFirmadoComponent } from './../../empresas/adjuntar-archivo-firmado/adjuntar-archivo-firmado.component';
import { AdjuntarArchivoEmpresaComponent } from './../../empresas/adjuntar-archivo/adjuntar-archivo-empresa.component';
import { ConfiguracionContratoMarcoComponent } from './../../empresas/contratos-marco/configuracion-contrato-marco/configuracion-contrato-marco.component';
import { DetalleConfiguracionCmComponent } from './../../empresas/contratos-marco/detalle-configuracion-cm/detalle-configuracion-cm.component';
import { NuevoCmAdquirenteComponent } from './../../empresas/contratos-marco/nuevo-cm-adquirente/nuevo-cm-adquirente.component';
import { FacturacionComponent } from './../../facturacion/facturacion.component';
import { CpeFacturaComponent } from './../../facturacion/facturas/cpe-factura/cpe-factura.component';
import { FacturasComponent } from './../../facturacion/facturas/facturas.component';
import { ListadoCpeComponent } from './../../facturacion/listado-cpe/listado-cpe.component';
import { CpeNotaCreditoComponent } from './../../facturacion/nota-credito/cpe-nota-credito/cpe-nota-credito.component';
import { NotaCreditoComponent } from './../../facturacion/nota-credito/nota-credito.component';
import { CpeNotaDebitoComponent } from './../../facturacion/nota-debito/cpe-nota-debito/cpe-nota-debito.component';
import { NotaDebitoComponent } from './../../facturacion/nota-debito/nota-debito.component';
import { DetalleCpeComponent } from './../../facturacion/nuevo-cpe/detalle-cpe/detalle-cpe.component';
import { NuevoCpeComponent } from './../../facturacion/nuevo-cpe/nuevo-cpe.component';
import { ConcentracionFondoComponent } from './../../fondo/concentracion-fondo/concentracion-fondo.component';
import { DashboardConcentracionFondoComponent } from './../../fondo/concentracion-fondo/dashboard-concentracion-fondo/dashboard-concentracion-fondo.component';
import { FinanciamientoComponent } from './../../fondo/financiamiento/financiamiento.component';
import { ListadoFinanciamientoComponent } from './../../fondo/financiamiento/listado/listado-financiamiento.component';
import { ListadoAcfinComponent } from './../../fondo/financiamiento/acfin/listado-acfin.component';
import { FondoComponent } from './../../fondo/fondo.component';
import { NuevoQuejasReclamosComponent } from './../../libro-reclamaciones/quejas-reclamos/nuevo-quejas-reclamos/nuevo-quejas-reclamos.component';
import { RespuestaQuejasReclamosComponent } from './../../libro-reclamaciones/quejas-reclamos/respuesta-quejas-reclamos/respuesta-quejas-reclamos.component';
import { LetraComponent } from './../../negociables/letra/letra.component';
import { LetrasCambioComponent } from './../../negociables/letra/letras-cambio/letras-cambio.component';
import { RelacionDocnegociableFondoComponent } from './../../operaciones/evaluacion-operacion/relacion-docnegociable-fondo/relacion-docnegociable-fondo.component';
import { AdminLayoutRoutes } from './admin-layout.routing';
import { ListarFacturasGeneradasComponent } from 'app/reportes/rep-contabilidad/listar-facturas-generadas/listar-facturas-generadas.component';
import { OperacionesDetalladasTiempoComponent } from 'app/reportes/rep-contabilidad/operaciones-detalladas-tiempo/operaciones-detalladas-tiempo.component';
import { OperacionesGeneralComponent } from 'app/reportes/rep-contabilidad/operaciones-general/operaciones-general.component';
import { FacturasNegociadasFondoComponent } from 'app/reportes/rep-contabilidad/facturas-negociadas-fondo/facturas-negociadas-fondo.component';
import { FacturasNegSectorFondoComponent } from 'app/reportes/rep-contabilidad/facturas-neg-sector-fondo/facturas-neg-sector-fondo.component';
import { FacturasNegProcesoSectorComponent } from 'app/reportes/rep-contabilidad/facturas-neg-proceso-sector/facturas-neg-proceso-sector.component';
import { ListadoOperacionesEstadoComponent } from 'app/reportes/rep-finanzas/listado-operaciones-estado/listado-operaciones-estado.component';
import { ListadoFacturasVencidasComponent } from 'app/reportes/rep-cobranzas/listado-facturas-vencidas/listado-facturas-vencidas.component';
import { ListadoFacturasJudicialComponent } from 'app/reportes/rep-cobranzas/listado-facturas-judicial/listado-facturas-judicial.component';
import { ListadoFacturasMeritoComponent } from 'app/reportes/rep-cobranzas/listado-facturas-merito/listado-facturas-merito.component';
import { ListadoEmpresaClienteComponent } from 'app/reportes/rep-marketing/listado-empresa-cliente/listado-empresa-cliente.component';
import { ListadoEmpresaObligadoComponent } from 'app/reportes/rep-marketing/listado-empresa-obligado/listado-empresa-obligado.component';
import { ListadoEmpresaUltimaComponent } from 'app/reportes/rep-marketing/listado-empresa-ultima/listado-empresa-ultima.component';
import { RepCobranzasComponent } from 'app/reportes/rep-cobranzas/rep-cobranzas.component';
import { KpiClienteDeudorComponent } from 'app/reportes/rep-comercial/kpi-cliente-deudor/kpi-cliente-deudor.component';
import { KpiDeudorComponent } from 'app/reportes/rep-comercial/kpi-deudor/kpi-deudor.component';
import { ListadoOperacionesGeneralComponent } from 'app/reportes/rep-finanzas/listado-general/listado-general.component';

import { AvalJuridicoRComponent } from '../../empresas/aval-juridicos/aval-juridicos.component';
import { RegAvalComponent } from '../../empresas/aval-juridicos/reg-aval/reg-aval.component';
import { ListAvalComponent } from '../../empresas/aval-juridicos/list-aval/list-aval.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AdminLayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    HttpClientModule,
    MatSortModule,
    MatTableModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatMomentDateModule,
    MatNativeDateModule,
    SharedModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    NgxMaskModule.forRoot(),
    MatStepperModule,
    MatMenuModule,
    MatTabsModule,
    MatIconModule,
    MatDividerModule,
    AngularMultiSelectModule,
    MatChipsModule,
    SatPopoverModule,
    ChartsModule,
    ReportesModule,
    ComponentesGlobalesModule
  ],
  exports: [
    MatSortModule,
    ReactiveFormsModule,
    MatTableModule,
    MatExpansionModule,
    MatToolbarModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatMenuModule,
    MatInputModule,
    MatDatepickerModule,
    MatRadioModule,
    SharedModule,
    MatTabsModule,
    MatIconModule,
    MatDividerModule,
    MatChipsModule,
    SatPopoverModule,
    ChartsModule,
    ReportesModule,
    ComponentesGlobalesModule
  ],
  declarations: [
    EmpresasComponent,
    NegociablesComponent,
    FactoringComponent,
    CobranzaComponent,
    PagosComponent,
    CobranzasComponent,
    LiquidacionComponent,
    NuevaLiquidacionComponent,
    GenerarLiquidacionComponent,
    CorreoLiquidacionesComponent,
    LiquidacionesComponent,
    ListadoLiquidacionesComponent,
    PlanillaLiquidacionesComponent,
    UpgradeComponent,
    OperacionesComponent,
    ListadoDocNegComponent,
    FacturaElectronicaComponent,
    FacturaFisicaComponent,
    ReciboHonorarioComponent,
    ListadoEmpresasComponent,
    RegProveedorComponent,
    RegAdquirenteComponent,
    RegInversorComponent,
    Error1Component,
    PersonaComponent,
    ContactosComponent,
    ProveedoresComponent,
    AdquirentesComponent,
    ListAdquirenteComponent,
    ListProveedorComponent,
    RefBancariasComponent,
    FacturaComponent,
    ReciboComponent,
    SelecArchivoComponent,
    AdjuntarArchivoComponent,
    AdjuntarArchivoContactoComponent,
    SafeUrlPipe,
    ProformasComponent,
    ListadoProformasComponent,
    NuevoProformaComponent,
    ListadoDocumentosAsociadosComponent,
    ProformaDetalleComponent,
    NuevoRefBancariaComponent,
    ListadoPagoComponent,
    ListadoCobranzaComponent,
    DetallePagoComponent,
    AdquirentePagoComponent,
    NuevoCobranzaComponent,
    InsertarCobranzaComponent,
    ContratosMarcoComponent,
    NuevoContratoMarcoComponent,
    DetallePagoComponent,
    AdquirentePagoComponent,
    AdquirenteCuotaComponent,
    ReportesComponent,
    RepComercialComponent,
    ListadoRepComercialComponent,
    ReporteCalculoComisionComponent,
    ListarFacturasGeneradasComponent,
    OperacionesDetalladasTiempoComponent,
    ReporteClienteObligadoComponent,
    ReporteNumeroOperacionesComponent,
    ReporteFacturaNegociadaComponent,
    KpiClienteDeudorComponent,
    KpiDeudorComponent,
    ListadoOperacionesGeneralComponent,
    CavaliComponent,
    MetaComponent,
    AreaComponent,
    ListadoAreaComponent,
    NuevoAreaComponent,
    TablaMetaComponent,
    FormularioMetaComponent,
    TesoreriaComponent,
    DesembolsoComponent,
    ListadoDesembolsoComponent,
    NuevoDesembolsoComponent,
    GenerarDesembolsoComponent,
    ListaTipoCambioComponent,
    NuevoTipoCambioComponent,
    EditarTipoCambioComponent,
    ConfirmarDesembolsoComponent,
    DeudasComponent,
    ListadoDeudasComponent,
    ContabilidadComponent,
    ListadoRepConciliacionesComponent,
    DetalleRepConcilComponent,
    RegistroDeudasComponent,
    EditarAdquirenteComponent,
    BloqueomasivoComponent,
    DesbloqueoMasivoComponent,
    NuevoPlanillaLiquidacionComponent,
    GenerarDesembolsoLiquidacionComponent,
    ListadoPagoAdqComponent,
    DetallePagoAdqComponent,
    ListadoCavaliComponent,
    ProcesoCavaliComponent,
    RegistrarCavaliComponent,
    InversionComponent,
    InversionistasComponent,
    ListadoInversionistasComponent,
    NuevoInversionComponent,
    GenerarInversionComponent,
    LibroReclamacionesComponent,
    QuejasReclamosComponent,
    ListadoQuejasReclamosComponent,
    DetalleQuejasReclamosComponent,
    RespuestaQuejasReclamosComponent,
    NuevoQuejasReclamosComponent,
    FacturacionComponent,
    FacturasComponent,
    CpeFacturaComponent,
    NotaDebitoComponent,
    CpeNotaDebitoComponent,
    NotaCreditoComponent,
    CpeNotaCreditoComponent,
    ListadoCpeComponent,
    NuevoCpeComponent,
    DetalleCpeComponent,
    NegociacionesComponent,
    SimuladorComponent,
    ListadoSimuladorComponent,
    SimuladorNuevoComponent,
    DetalleSimuladorComponent,
    InsertarSimuladorDetalleComponent,
    InsertarSimuladorObjetivoComponent,
    InsertarSimuladorDetalleRhComponent,
    OperacionComponent,
    OperacionDetalleComponent,
    ListadoOperacionComponent,
    NotificarSolicitudDesembolsoComponent,
    NuevaOperacionComponent,
    GenerarOperacionComponent,
    SolicitudDesembolsoComponent,
    ListadoSolicitudDesComponent,
    SolicitudDesDetalleComponent,
    NuevoSolicitudDesComponent,
    GenerarSolicitudDesComponent,
    ListadoCobranzaJudicialComponent,
    NuevoCobranzaJudicialComponent,
    DetalleCobranzaJudicialComponent,
    CancelarCobranzaJudicialComponent,
    ListadoReprogramacionComponent,
    NuevoReprogramacionComponent,
    DetalleReprogramacionComponent,
    CancelarReprogramacionComponent,
    RiesgoComponent,
    FondoComponent,
    DashboardConcentracionFondoComponent,
    ListadoFinanciamientoComponent,
    ListadoAcfinComponent,
    FinanciamientoComponent,
    ConcentracionFondoComponent,
    EmpresaRiesgoComponent,
    ListadoEmpresaRiesgoComponent,
    NuevaEmpresaRiesgoComponent,
    ContactoEmpresaComponent,
    ListadoExcepcionesComponent,
    NuevoPagareComponent,
    ContratoMarcoComponent,
    ListadoContratoMarcoComponent,
    PagareComponent,
    NuevoCmAdquirenteComponent,
    ConfiguracionContratoMarcoComponent,
    DetalleConfiguracionCmComponent,
    AdjuntarArchivoEmpresaComponent,
    AdjuntarArchivoFirmadoComponent,
    AdjuntarLogoComponent,
    DocumentosSubastaComponent,
    ListadoDnSubastaComponent,
    ListadoDocumentosXSubastarComponent,
    NuevoDnSubastaComponent,
    RepFinanzasComponent,
    FondoInversionComponent,
    AccialComponent,
    DetalleNotaCpeComponent,
    VerificacionPlanillaDesembolsoComponent,
    DetalleListadoComponent,
    InversoresComponent,
    ListInversoresComponent,
    ConfInversoresComponent,
    NuevoContactoComponent,
    NuevoCorteComponent,
    FacturacionDeudaComponent,
    PagarDeudaComponent,
    LetraComponent,
    LetrasCambioComponent,
    UsuarioComponent,
    ListaUsuarioComponent,
    NuevoUsuarioComponent,
    EmpresaSegComponent,
    ListadoComponent,
    NuevoEmpresaComponent,
    SistemaComponent,
    ListadoSistemaComponent,
    NuevoSistemaComponent,
    RolComponent,
    ListadoRolComponent,
    NuevoRolComponent,
    ComponentesComponent,
    ListadoComponenteComponent,
    NuevoComponenteComponent,
    ParametroComponent,
    PermisoComponenteComponent,
    NuevoParametroComponent,
    AccesoComponent,
    ListadoAccesoComponent,
    NuevoAccesoComponent,
    PermisoComponent,
    ListadoPermisoComponent,
    NuevoPermisoComponent,
    GuiasComponent,
    ListadoGuiaComponent,
    NuevoGuiaComponent,
    DetalleGuiaComponent,
    LetrasCambioComponent,
    ProspectosComponent,
    ListadoOperacionesProspectosComponent,
    NuevoProspectosComponent,
    ProspectoRespuestaComponent,
    NuevaRespuestaProspectoComponent,
    ListadoProspectosComponent,
    ProspectosDetalleComponent,
    SubDashboardComponent,
    UppercaseDirective,
    NuevoContactoPagareComponent,
    RepContabilidadComponent,
    ComprobanteElectronicoComponent,
    DetComprobanteElectronicoComponent,
    ListaComprobanteElectronicoComponent,
    CargaMasivaComponent,
    ComprobanteIfComponent,
    ListaComprobanteIfComponent,
    PagaresComponent,
    ListadoPagareComponent,
    AvalJuridicoComponent,
    EvaluacionOperacionComponent,
    ListaEvaluacionOperacionComponent,
    DetalleEvaluacionOperacionComponent,
    NuevoEvaluacionOperacionComponent,
    ListaDocumentosComponent,
    RelacionDocnegociableFondoComponent,
    RepConciliacionComponent,
    RepMensualComponent,
    // RepConcarComponent,
    CarteraRiesgoComponent,
    ListadoCarteraRiesgoComponent,
    ListadoSectorComponent,
    NuevoSectorComponent,
    ConfiguracionRiesgoComponent,
    SectorEmpresaComponent,
    AsignarSectorComponent,
    FondosComponent,
    ListadoFondosComponent,
    NuevoFondoComponent,
    GarantiasComponent,
    ListadoGarantiasComponent,
    NuevaGarantiaComponent,
    InlineEditComponent,
    PagosDetalleComponent,
    InlineBlackListComponent,
    FacturasNegociadasFondoComponent,
    ListaNegraComponent,
    RepMarketingComponent,
    ListadoRepMarketingComponent,
    OperacionesGeneralComponent,
    ResumenLiquidacionComponent,
    ListadoResumenComponent,
    NuevoResumenComponent,
    ListadoFacturasMeritoComponent,
    ListadoFacturasVencidasComponent,
    ListadoFacturasJudicialComponent,
    ListadoOperacionesEstadoComponent,
    ListadoEmpresaClienteComponent, 
    ListadoEmpresaObligadoComponent, 
    ListadoEmpresaUltimaComponent,
    DetalleResumenComponent,
    DetalleLiquidacionesComponent,
    InlineContactosComponent,
    FacturasNegProcesoSectorComponent,
    LineaAdquirenteComponent,
    FacturasNegSectorFondoComponent,
    ListaLineasComponent,
    NuevaLineaComponent,
    DetalleLineaComponent,
    ListadoConfirmingComponent,
    GenerarConfirmingComponent,
    NuevaConfirmingComponent,
    ConfirmingDetalleComponent,
    ConfirmingComponent,
    RepCobranzasComponent,
    FactorComponent,
    ListFactorComponent,
    RegFactorComponent,
    FacturaElectronicaccComponent,
    FacturaccComponent,
    AvalJuridicoRComponent,
    ListAvalComponent,
    RegAvalComponent
  ],
  providers: [
    SecurityService,
    ThemeService
  ]
})

export class AdminLayoutModule { }
